import { EcommerceEventGaEvents, GaEvents, GAEventBase } from '../../models/services/ga/ga';

const initialiseDataLayer = () => (!window.dataLayer ? (window.dataLayer = []) : null);

const gaTagsBaseProperties = (): GAEventBase | undefined => {
  if (import.meta.env.VITE_ENABLE_GTM !== 'true') {
    return;
  }
  const environment = import.meta.env;
  initialiseDataLayer();
  return {
    version: 'WiB',
    domainId: environment.VITE_CLIENT_FRIENDLY_NAME.replaceAll(' ', '').toUpperCase(),
    brand: environment.VITE_BRAND_CODE.trim(),
    country: 'USA',
    customerType: 'G',
  };
};

export const gaPageView = <T extends GaEvents = GaEvents>(tags: T) => {
  if (import.meta.env.VITE_ENABLE_GTM !== 'true') {
    return;
  }

  const salesWidgetClicked =
    'salesWidgetClicked' in tags ? (tags.salesWidgetClicked ? 'Yes' : 'No') : undefined;

  const offerStatus = 'offerStatus' in tags ? (tags.offerStatus ? '1' : '0') : undefined;

  const baseProperties = gaTagsBaseProperties();
  window.dataLayer.push({
    ...tags,
    ...baseProperties,
    salesWidgetClicked,
    offerStatus,
    event: 'spa-pageview',
  });
};

export const gaEvent = <T extends GaEvents = GaEvents>(tags: T) => {
  if (import.meta.env.VITE_ENABLE_GTM !== 'true') {
    return;
  }
  const baseProperties = gaTagsBaseProperties();

  const salesWidgetClicked =
    'salesWidgetClicked' in tags ? (tags.salesWidgetClicked ? 'Yes' : 'No') : undefined;

  const offerStatus = 'offerStatus' in tags ? (tags.offerStatus ? '1' : '0') : undefined;

  window.dataLayer.push({
    ...tags,
    ...baseProperties,
    salesWidgetClicked,
    offerStatus,
    event: 'event' in tags ? tags.event : 'genericGAEvent',
  });
};

export const gaECommerceEvent = <T = EcommerceEventGaEvents>(tags: T) => {
  if (import.meta.env.VITE_ENABLE_GTM !== 'true') {
    return;
  }
  initialiseDataLayer();
  window.dataLayer.push({
    ...tags,
  });
};
